export const money = new Intl.NumberFormat("it-IT", {
  style: "currency",
  currency: "EUR",
});




export const baseUrl = "";
